import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { defaultApplication } from '@/utilities/constants';

export const application = {
  namespaced: true,
  state: Object.assign({},
    {
      applicationList: {
        items: [],
        isLoading: false
      }
    },
    {
      application: { ...defaultApplication }
    }
  ),
  actions,
  getters,
  mutations
};
